exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/indigo-pink.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.swal2-popup { font-size: 1.6rem !important; }\n\n.header_menu{\n    color:#fff !important;\n}\n\n.header_menu:hover{\n    color:#cb875f !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/html/oneills-web-qa/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/var/www/html/oneills-web-qa/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles